import { Box, Typography } from '@mui/material';
import React, { FC } from 'react';
import { useStyles } from './DepositCryptoInstructions.styles';

export const DepositCryptoInstructions: FC = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <ol className={classes.list}>
        <li>
          <Typography>
            Scan or copy the deposit address and use it as a deposit destination in your crypto
            wallet application (e.g. MetaMask, Coinbase Wallet, Binance).
          </Typography>
        </li>
        <li>
          <Typography mb={1}>
            Select supported network: <b>Polygon (required)</b>.
          </Typography>
          <ul>
            <li>
              <Typography>
                WARNING: Make sure you have selected supported network. Otherwise funds will be
                lost!
              </Typography>
            </li>
          </ul>
        </li>
        <li>
          <Typography>
            Choose deposit amount and run transaction (it usually takes a few minutes).
          </Typography>
        </li>
      </ol>
    </Box>
  );
};
